export default __webpack_public_path__ + "static/media/Rampver_Online_Logo-main.74886f98.png";